import React from 'react';
import styled from 'styled-components';
import constants from '../../../../core/constants';
import IDHelpers from '../../../../core/helpers/IDHelper';

const HoursElement = styled.div`
  width: 82px;
  background: #f7fbfd;
`;

const ItemHour = styled.div`
  height: 100px;
  width: 82px;
  justify-content: flex-end;
  display: flex;
  position: relative;
  background: #f7fbfd;
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    height: 80px;
  }
`;

const ItemHourText = styled.div`
  color: var(--text-text02);
  font-size: 10px;
  line-height: 20px;
  top: -10px;
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 12px;
`;

const ItemHourBorderTop = styled.div.attrs((props: any) => ({
  isFirst: props.isFirst
}))`
  height: 40px;
  width: 15px;
  border-top-width: ${(props) => (props.isFirst ? '0' : '1')}px;
  border-right-width: 0px;
  border-color: var(--background-background-disabled);
  // margin-left: 12px;
  position: absolute;
`;

function HoursOfDay(props: any) {
  const { start, end } = props;
  const items = [];
  for (let index = start; index <= end; index += 1) {
    items.push(
      <ItemHour key={IDHelpers.generateID()}>
        <ItemHourText>
          {index === start ? '' : `${index.toString()}:00`}
        </ItemHourText>
        <ItemHourBorderTop isFirst={index === start} />
      </ItemHour>
    );
  }
  return <HoursElement>{items}</HoursElement>;
}

export default HoursOfDay;
